uniform float uTime;
uniform float uDeltaTime;
uniform sampler2D uBase;
uniform sampler2D uBase2;
uniform float uMorphAmount;
uniform vec3 uMouse;
uniform float uMouseRadius;
uniform float uMouseAspect;
uniform float uSuckAmount;
uniform float uMouseTrail;
uniform float uDecayRate;

#include ../includes/simplexNoise4d.glsl

float rectDist(vec3 pos, vec3 center, float radius, float aspect)
{
    vec3 d = abs(pos - center);
    float dx = d.x / (radius * aspect);
    float dy = d.y / (radius / aspect);
    float dz = d.z / radius;
    return max(max(dx, dy), dz);
}

void main()
{
    float time = uTime * 0.2;
    vec2 uv = gl_FragCoord.xy / resolution.xy;
    vec4 particle = texture(uParticles, uv);

    // Dead — respawn
    if(particle.a >= 1.0)
    {
        particle.a = mod(particle.a, 1.0);

        // Some particles spawn from mouse as a smoke trail
        float spawnNoise = simplexNoise4d(vec4(uv * 100.0, time * 5.0, 0.0));
        if(uMouse.x < 9000.0 && uMouseTrail > 0.0 && uSuckAmount < 0.1 && spawnNoise > (1.0 - uMouseTrail))
        {
            vec3 offset = vec3(
                simplexNoise4d(vec4(uv * 50.0, time * 10.0, 1.0)),
                simplexNoise4d(vec4(uv * 50.0, time * 10.0, 2.0)),
                simplexNoise4d(vec4(uv * 50.0, time * 10.0, 3.0))
            ) * 0.3;
            particle.xyz = uMouse + offset;
        }
        else
        {
            vec3 base1 = texture(uBase, uv).xyz;
            vec3 base2 = texture(uBase2, uv).xyz;
            particle.xyz = mix(base1, base2, uMorphAmount);
        }
    }
    // Alive
    else
    {
        vec4 velocity = texture(uVelocity, uv);
        particle.xyz += velocity.xyz * uDeltaTime;

        // Decay — particles near cursor despawn faster when sucking
        float decay = uDecayRate;
        if(uSuckAmount > 0.01) {
            float mouseDist = length(particle.xy - uMouse.xy);
            float fadeRadius = uMouseRadius * 0.6;
            float proximity = 1.0 - smoothstep(0.0, fadeRadius, mouseDist);
            // Use absolute minimum rate so it works even with low respawnRate
            float suckDecay = max(uDecayRate * 5.0, 3.0);
            decay = mix(decay, suckDecay, proximity * uSuckAmount);
        }
        particle.a += uDeltaTime * decay;
    }

    gl_FragColor = particle;
}
